import { Api } from 'models/services/api';
import { CreateBusinessCategoryQuery } from 'models/services/graphql';

import { BusinessCategoryData, BusinessCategoryDataToSave } from '../index';

type DataToCreate = {
  input: BusinessCategoryDataToSave;
};

const RequestQuery = `
  mutation CreateBusinessCategory($input: BusinessCategoryInput!) {
    ${CreateBusinessCategoryQuery}
  }
`;

type ResponseData = {
  data: {
    createBusinessCategory: BusinessCategoryData
  }
}

class CreateGql {

  readonly api: Api<ResponseData>;
  readonly document?: BusinessCategoryData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToCreate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.createBusinessCategory;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { CreateGql };